import { render } from "./index.vue?vue&type=template&id=2e916f3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2e916f3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e916f3e"],['__file',"src/components/BaseUi/Switch/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e916f3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e916f3e', __exports__)) {
    api.reload('2e916f3e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2e916f3e&scoped=true", () => {
    api.rerender('2e916f3e', render)
  })

}


export default __exports__